enum CivilStateMarriagePartnershipChangeType {
    // These values may not be changed! The service bus relies on these exact values.
    // Should match with platform/lib/services/entity/enum/CivilState.php
    Married = 'married',
    RegisteredPartnership = 'registered_partnership',
}

export default CivilStateMarriagePartnershipChangeType;
